import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { useState } from 'react';
import BillingDocumentsTable from './components/billing-documents-table';
import { ILxsBillingDocumentsViewProps } from './lxs-billing-documents';

const LxsBillingDocumentsView: React.FC<ILxsBillingDocumentsViewProps> = ({
    context,
    LxsBillingDocumentsProps,
    resources,
    billingDocuments,
    localizationState
}) => {
    const [globalFilter, setGlobalFilter] = useState('');
    const CLASS_NAME = 'lxs-billing-documents';

    return (
        <Module {...LxsBillingDocumentsProps}>
            {billingDocuments ? (
                <div>
                    <BillingDocumentsTable
                        CLASS_NAME={CLASS_NAME}
                        resources={resources}
                        globalFilter={globalFilter}
                        localizationState={localizationState}
                        data={billingDocuments.value}
                        context={context}
                        setGlobalFilter={setGlobalFilter}
                    />
                </div>
            ) : (
                <div className='alert alert-info' role='alert'>
                    {resources.lxsBillingDocumentsNoDocumentsFound}
                </div>
            )}
        </Module>
    );
};

export default LxsBillingDocumentsView;
